// Subtract 3db when panned far left or right

import convertDBtoLinear from "util/convertDBtoLinear";
import { PlaybackControls } from "../types";

const permanentOffsetToAvoidClipping = 5;

// www.soundonsound.com/sound-advice/q-what-pan-law-setting-should-use
function panLawAdjustment(pan: number) {
  return Math.abs(3 * pan); // pan is -1 to 1 so this is 0 to 3 with 0 being center and 3 being far left or right
}

export default function getVolume({ volume, pan }: PlaybackControls): number {
  return convertDBtoLinear(
    volume - panLawAdjustment(pan) - permanentOffsetToAvoidClipping
  );
}
